export default {
  setEntity (state, payload) {
    state.entity = payload
  }
}